export default "__VITE_ASSET__DzVxPkiM__"